import { Card } from "antd"
import "./index.css"

const ErrorComponent = (props) => {
    return(
        <div className="error-container">
            <Card 
            className="error-card-width"
            
            >
                <img src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/error.svg">
                </img>
                <div className="error-text" >Error</div>
                <p>Invalid CPIN , Please check and try again</p>
                <p>
                    CPIN  : {props.transaction_data?.CPIN}
                </p>
            </Card>
        </div>
    )
}
export default ErrorComponent